import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['label', 'modalTitle', 'deleteBtn', 'activeInput', 'activeIcon', 'activeValue', 'visibleHint', 'hiddenHint']
  static values = {
    onText: {
      type: String,
      default: 'Visible'
    },
    offText: {
      type: String ,
      default: 'Hidden'
    }
  }

  connect() {
    this.updateDOM(this.activeInputTarget.checked)
  }

  editItem() {
    this.modalTitleTarget.innerHTML = 'Edit'
    if (this.hasDeleteBtnTarget) {
      this.deleteBtnTarget.classList.remove('hidden')
    }
    this.dispatch('showModal')
  }

  toggleActive() {
    const active = !this.activeInputTarget.checked
    this.updateDOM(active)
  }


  updateDOM(active) {
    this.activeInputTarget.checked = active
    this.element.classList.toggle('hide', !active)
    // List rows (e.g. _list_policy_row) only have the active input, not the modal's icon, value and hints
    if (this.hasActiveIconTarget) this.activeIconTarget.classList.toggle('hide', !active)
    if (this.hasActiveValueTarget) this.activeValueTarget.innerHTML = active ? this.onTextValue : this.offTextValue
    if (this.hasVisibleHintTarget) this.visibleHintTarget.classList.toggle('hidden', !active)
    if (this.hasHiddenHintTarget) this.hiddenHintTarget.classList.toggle('hidden', active)
  }

  updateLabel(e) {
    const target = e.target

    // Handle select elements
    if (target.tagName === 'SELECT') {
      if (target.multiple) {
        const selectedOptions = Array.from(target.selectedOptions)
        if (selectedOptions.length === 0) {
          this.labelTarget.innerHTML = 'All (catch-all)'
        } else {
          this.labelTarget.innerHTML = selectedOptions.map(opt => opt.text).join(', ')
        }
      } else {
        // Single select - use selected option text
        const selectedOption = target.selectedOptions[0]
        this.labelTarget.innerHTML = selectedOption ? selectedOption.text : ''
      }
    } else {
      // Text input or other elements - use value directly
      this.labelTarget.innerHTML = target.value
    }
  }
}
